import ObjectID from 'bson-objectid';

import generateSurveyLists from '../../../helpers/generateSurveyLists/generateSurveyLists';

export default (state, parentGroupId) => {
  const newSurvey = JSON.parse(JSON.stringify(state.survey));

  const newGroupId = ObjectID().toString();

  const parentGroupIndex = newSurvey.content.groups.findIndex(
    g => g.id === parentGroupId
  );

  const alreadyGroupsInParent =
    (parentGroupIndex || parentGroupIndex === 0) &&
    newSurvey.content.groups[parentGroupIndex] &&
    newSurvey.content.groups[parentGroupIndex].flows
      ? newSurvey.content.groups[parentGroupIndex].flows.length
      : 0;

  const newGroup = {
    id: newGroupId,
    flows: [],
    label: `Group ${alreadyGroupsInParent + 1}`
  };

  newSurvey.content.groups[parentGroupIndex].flows = [
    ...newSurvey.content.groups[parentGroupIndex].flows,
    newGroupId
  ];

  newSurvey.content.groups.push(newGroup);

  const newState = {
    ...state,
    survey: {
      ...state.survey,
      content: newSurvey.content,
      questions: newSurvey.questions
    }
  };

  // Check if any of the questions have flowJump pointing to the nextQuestion as a result of question move
  newState.surveyLists = generateSurveyLists(
    newState.survey.content,
    newState.survey.questions
  );

  return { newState };
};
